import React from 'react';
import { Routes, Route } from 'react-router-dom';
import { AdminAuthProvider } from '@/contexts/AdminAuthContext';
import AdminLayout from '@/components/admin/AdminLayout';
import AdminLoginPage from '@/pages/AdminLoginPage';
import AdminDashboardPage from '@/pages/AdminDashboardPage';
import AdminUsersPage from '@/pages/AdminUsersPage';
import AdminAdminsPage from '@/pages/AdminAdminsPage';
import AdminBlogsPage from '@/pages/AdminBlogsPage';
import AdminLogsPage from '@/pages/AdminLogsPage';
import AdminSupportPage from '@/pages/AdminSupportPage';
import AdminSettingsPage from '@/pages/AdminSettingsPage';

const AdminRoutes: React.FC = () => {
  return (
    <AdminAuthProvider>
      <Routes>
        <Route path="/login" element={<AdminLoginPage />} />
        <Route path="/" element={<AdminLayout />}>
          <Route index element={<AdminDashboardPage />} />
          <Route path="users" element={<AdminUsersPage />} />
          <Route path="admins" element={<AdminAdminsPage />} />
          <Route path="blogs" element={<AdminBlogsPage />} />
          <Route path="logs" element={<AdminLogsPage />} />
          <Route path="support" element={<AdminSupportPage />} />
          <Route path="settings" element={<AdminSettingsPage />} />
        </Route>
      </Routes>
    </AdminAuthProvider>
  );
};

export default AdminRoutes;
